import { requestPlaylistContainerSection } from '@/composables/playlistContainerSectionRequest';
import { useOpenRecordInInspector } from '@/composables/useOpenRecordInInspector';

/**
 * What a click on a bucket's or custom list's count does: open that record's
 * inspector on the section the count is about.
 *
 * On the record's own search card, the card itself opens the record. So the
 * count leaves a section request and lets the click carry on to the card.
 *
 * On a card for something else, the card opens that other record. The schedule
 * search page draws each schedule with its custom list's card, and a click on
 * the card opens the schedule. So there the count opens the list's inspector
 * itself, and stops the click before it reaches the card.
 */
export function useOpenContainerSection(opensOwnInspector: () => boolean) {
    const { openRecord } = useOpenRecordInInspector();

    return function openSection(event: MouseEvent, entityId: string, recordId: unknown, section: string): void {
        if (opensOwnInspector()) {
            event.stopPropagation();
            openRecord(entityId, recordId as number | string, { initialSection: section });
            return;
        }
        requestPlaylistContainerSection(entityId, recordId, section);
    };
}
